import React from 'react';
import { trendingNews } from '../data/newsData';
export const Sidebar = () => {
  return <aside className="space-y-8" data-id="element-273">
      {/* Newsletter Signup */}
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-274">
        <h3 className="text-lg font-bold mb-3" data-id="element-275">Get the Daily Briefing</h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-276">
          Stay informed with our daily newsletter, delivered straight to your
          inbox.
        </p>
        <form className="space-y-3" data-id="element-277">
          <input type="email" placeholder="Your email address" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-278" />
          <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors" data-id="element-279">
            Subscribe
          </button>
        </form>
      </div>
      {/* Trending News */}
      <div data-id="element-280">
        <h3 className="text-lg font-bold mb-4 pb-2 border-b border-gray-200" data-id="element-281">
          Trending
        </h3>
        <div className="space-y-4" data-id="element-282">
          {trendingNews.map((item, index) => <div key={index} className="flex gap-3" data-id="element-283">
              <span className="text-2xl font-bold text-gray-300" data-id="element-284">
                {index + 1}
              </span>
              <div data-id="element-285">
                <h4 className="font-medium text-gray-900 mb-1" data-id="element-286">{item.title}</h4>
                <span className="text-xs text-gray-500" data-id="element-287">{item.date}</span>
              </div>
            </div>)}
        </div>
      </div>
      {/* Ad Space */}
      <div className="bg-gray-100 p-4 rounded-lg text-center" data-id="element-288">
        <p className="text-xs text-gray-500 mb-2" data-id="element-289">ADVERTISEMENT</p>
        <div className="bg-gray-200 h-48 flex items-center justify-center" data-id="element-290">
          <span className="text-gray-400" data-id="element-291">Ad Space</span>
        </div>
      </div>
    </aside>;
};